<template>
  <div class="tw-gap-[12px] tw-flex">
    <Plus
      v-for="(item, index) in qualityData"
      :key="index"
      :color="item"
    ></Plus>
  </div>
</template>

<script lang="ts" setup>
import Plus from "@/components/svgs/plus.vue";
import { ref, watch, onMounted } from "vue";
import { convertQuality } from "@/utils/utilities";
import { QUALITY_ASSESSMENT_TYPE } from "@/utils/constants";
const props = defineProps({
  data: {
    type: String,
    required: true,
    default: "l",
  },
  type: {
    type: String,
    required: false,
    default: QUALITY_ASSESSMENT_TYPE.IMPORTANCE,
  },
  isCompleted: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const qualityData: any = ref([]);

watch(
  () => props.data,
  (newVal) => {
    qualityData.value = progressData(newVal);
  },
);

const progressData = (data) => {
  return convertQuality(data, props.isCompleted, props.type);
};
onMounted(() => {
  qualityData.value = progressData(props.data);
});
</script>

<style lang="scss" scoped>
.header__pen {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  padding: 9px 14px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  width: 46px;
  height: 44px;
}

.is_editable {
  background: var(--Brand-Navy, #211f58);
}

.not_editable {
  background: var(--UI-white, #fff);
}
</style>
